// extracted by mini-css-extract-plugin
export var list = "Logos-module--list--KAfYH";
export var logo = "Logos-module--logo--nNphs";